import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.79959 8.125C6.39979 8.625 5.60021 8.625 5.20041 8.125L2.70171 5C2.20754 4.38197 2.67768 3.5 3.5013 3.5L8.4987 3.5C9.32232 3.5 9.79246 4.38197 9.29829 5L6.79959 8.125Z"
        fill="white"
        fillOpacity="0.85"
      />
    </svg>
  );
};

export default Icon;
